// extracted by mini-css-extract-plugin
export default {"container":"style_container__7JBEU","track":"style_track__UxyoU","slide":"style_slide__Meiu-","overlay":"style_overlay__Il5Hr","title":"style_title__jj+Lr"};